//---------------------------
// check name already exists
//---------------------------
export default function isName(name, names) {
  if (names.length > 0) {
    return names.includes(name);
  }
  return false;
}
